import { useTranslation } from 'react-i18next';
import { StatusBadge } from '@components/atoms/ui-kit/badge';
import type { StatusTone } from '@utils/constants/status-map';
import type { ConnectionStatus } from '@utils/types/connections/connection.ts';

interface Props {
  status: ConnectionStatus;
}

const TONES: Record<ConnectionStatus, StatusTone> = {
  connected: 'success',
  needs_reconnect: 'warn',
  failed: 'danger',
  pending: 'info'
};

const LABEL_KEYS: Record<ConnectionStatus, string> = {
  connected: 'publishing-status-connected',
  needs_reconnect: 'publishing-status-needs-reconnect',
  failed: 'publishing-status-failed',
  pending: 'publishing-status-pending'
};

export default function ConnectionStatusBadge({ status }: Props) {
  const { t } = useTranslation();
  return (
    <StatusBadge
      status={status}
      tone={TONES[status]}
      label={t(LABEL_KEYS[status])}
    />
  );
}
